<template>
  <div>
    <PageAllow controller="ShopProfit" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 按钮 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("ShopProfitDetail.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherShop v-model="shopSelected" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shop_profit_details"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="1">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ sale_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ cost_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ profit_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}</span
                  >
                </td>
                <!-- <td></td> -->
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.sale_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ sale_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.cost_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ cost_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ShopProfitDetail.Fields.profit_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ profit_total | formatTwoDot }}
                  </div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ShopProfitDetail.Fields.profit_total_rate") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <!-- 数量 -->
            <template v-slot:item.default_out_num="{ item }">
              <span v-if="item.default_out_num">
                {{ item.default_out_num | formatTwoDot }}
              </span>
              <span v-if="item.default_out_num == null">
                {{ item.confirm_num | formatTwoDot }}
              </span>
            </template>
            <!-- 单位 -->
            <template v-slot:item.unit="{ item }">
              <span v-if="item.default_out_num">
                {{ item.default_unit }}
              </span>
              <span v-if="item.default_out_num == null">
                {{ item.unit }}
              </span>
            </template>

            <!-- 毛利率 -->
            <template v-slot:item.profits_rate="{ item }">
              {{ item.profits_rate | formatTwoDot(true)
              }}{{ $t("Global.rate") }}
            </template>
            <!-- 成本 -->
            <template v-slot:item.costs="{ item }">
              {{ $t("Global.money") }}{{ item.costs | formatMoney }}
            </template>
            <!-- 毛利 -->
            <template v-slot:item.profits="{ item }">
              {{ $t("Global.money") }}{{ item.profits | formatMoney }}
            </template>
            <!-- 销售额 -->
            <template v-slot:item.salesAmount="{ item }">
              {{ $t("Global.money") }}{{ item.salesAmount | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import ShopProfitAnalyze from "@/api/shop_profit_analyze.js";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherShop from "@/components/plugins/SearcherShop";
import Shops from "@/api/shops";
import consts from "@/consts";

const defaultOptions = {
  district_id: "",
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",

  actual_time_from: "",
  actual_time_to: "",
};

export default {
  data: () => ({
    shopSelected: null,

    shop_profit_details: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    profit_total_rate: 0,
    profit_total: 0,
    cost_total: 0,
    sale_total: 0,
    orderProfitKeyword: "",
    codeKeyword: "",
  }),
  components: {
    Breadcrumbs,
    PageAllow,
    SearcherDatetimeRangeWithRadio,
    SearcherShop,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.profitAnalyze"),
          disabled: false,
          href: "/order-profit",
        },
        {
          text: i18n.t("Nav.shopProfit", [consts.shopName()]),
          disabled: true,
        },
      ];
      // if(this.$route.params.id){
      //     items.push({
      //         text:this.$route.params.id,
      //         disabled:false,
      //         accent:true,
      //     });
      // }
      return items;
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ShopProfitAnalyze.Fields.created_date"),
      },
      {
        key: "actual",
        text: i18n.t("ShopProfitAnalyze.Fields.actual_time"),
      },
    ],
    headers() {
      var headers = [];
      if (
        this.options &&
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "created"
      )
        headers.push({
          text: i18n.t("ShopProfitDetail.Fields.created"),
          align: "start",
          sortable: false,
          value: "date",
        });
      if (
        this.options &&
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      )
        headers.push({
          text: i18n.t("ShopProfitDetail.Fields.actual_date"),
          align: "start",
          sortable: false,
          value: "date",
        });
      return headers.concat([
        {
          text: i18n.t("ShopProfitDetail.Fields.salesAmount"),
          align: "end",
          sortable: false,
          value: "salesAmount",
        },
        // 成本
        {
          text: i18n.t("ShopProfitDetail.Fields.costs"),
          align: "end",
          sortable: false,
          value: "costs",
        },
        // 毛利
        {
          text: i18n.t("ShopProfitDetail.Fields.profits"),
          align: "end",
          sortable: false,
          value: "profits",
        },
        //毛利率
        {
          text: i18n.t("ShopProfitDetail.Fields.profits_rate"),
          align: "end",
          sortable: false,
          value: "profits_rate",
        },
      ]);
    },
    ...mapState([
      // "districtID"
    ]),
  },

  mounted() {
    this.getShopFromAPI();

    // this.$store.commit("districtID", 0);
    this.$store.commit("searchDistrict", false);
    this.$commonUtils.loadOptions("shop_profit_analyze", []).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
      }.bind(this)
    );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options);

      this.getDistributionMAFromAPI();
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getShopFromAPI() {
      Shops.fetchOne(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shop = response.data.shop;
            this.shopSelected = this.shop;
          }
        }.bind(this)
      );
    },

    getDistributionMAFromAPI() {
      this.loading = true;
      ShopProfitAnalyze.fetchOne(
        Object.assign({}, this.options, { id: this.$route.params.id })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shop_profit_details = response.data.shop_profit_details;

            this.profit_total_rate = response.data.profit_total_rate;
            this.profit_total = response.data.profit_total;
            this.sale_total = response.data.sale_total;
            this.cost_total = response.data.cost_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      ShopProfitAnalyze.exportOne(
        this.$route.params.id,
        Object.assign({}, this.options, { id: this.$route.params.id })
      );
    },
  },
  watch: {
    // districtID: {
    //   handler() {
    //     this.getDistributionMAFromAPI();
    //   },
    // },
    options: {
      deep: true,
      handler() {
        this.getDistributionMAFromAPI();
        sessionStorage.setItem(
          "shop_profit_analyze-options",
          JSON.stringify(this.options)
        );
      },
    },

    shopSelected: {
      handler() {
        if (
          this.shopSelected &&
          this.shopSelected.id != this.$route.params.id
        ) {
          this.$router.replace("/shop-profit/detail/" + this.shopSelected.id);
          this.getDistributionMAFromAPI();
        }
      },
    },
  },
};
</script>

<style>
</style>